/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic
 *
 * The version of the OpenAPI document: 0.1.1
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EventResponseRecordsInnerEventActivated
 */
export interface EventResponseRecordsInnerEventActivated {
    /**
     * 
     * @type {Array<number>}
     * @memberof EventResponseRecordsInnerEventActivated
     */
    coordinates?: Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof EventResponseRecordsInnerEventActivated
     */
    extensions?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof EventResponseRecordsInnerEventActivated
     */
    type?: string;
}

/**
 * Check if a given object implements the EventResponseRecordsInnerEventActivated interface.
 */
export function instanceOfEventResponseRecordsInnerEventActivated(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function EventResponseRecordsInnerEventActivatedFromJSON(json: any): EventResponseRecordsInnerEventActivated {
    return EventResponseRecordsInnerEventActivatedFromJSONTyped(json, false);
}

export function EventResponseRecordsInnerEventActivatedFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventResponseRecordsInnerEventActivated {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'coordinates': !exists(json, 'coordinates') ? undefined : json['coordinates'],
        'extensions': !exists(json, 'extensions') ? undefined : json['extensions'],
        'type': !exists(json, 'type') ? undefined : json['type'],
    };
}

export function EventResponseRecordsInnerEventActivatedToJSON(value?: EventResponseRecordsInnerEventActivated | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'coordinates': value.coordinates,
        'extensions': value.extensions,
        'type': value.type,
    };
}

